var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.54025 15.4493L1 17L2.55127 11.4619L12.6961 1.37028C12.8107 1.25307 12.9477 1.15993 13.0988 1.09634C13.25 1.03276 13.4124 1 13.5764 1C13.7404 1 13.9027 1.03276 14.0539 1.09634C14.2051 1.15993 14.342 1.25307 14.4567 1.37028L16.6358 3.5609C16.7512 3.67531 16.8428 3.81143 16.9053 3.9614C16.9678 4.11137 17 4.27223 17 4.43469C17 4.59716 16.9678 4.75801 16.9053 4.90799C16.8428 5.05796 16.7512 5.19407 16.6358 5.30848L6.54025 15.4493Z",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editPencil.ea9374c9.svg";
export { ForwardRef as ReactComponent };